import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';
export class AccessibilityKLO extends Component {
    displayName = AccessibilityKLO.name

    constructor(props) {
        super(props);
    }
    componentDidMount() {
        ReactGA.initialize(
            [
                {
                    trackingId: 'UA-2905701-8',
                    gaOptions: { name: 'tracker1' }
                },
                {
                    trackingId: 'UA-72849501-2',
                    gaOptions: { name: 'tracker2' }
                }
            ],
            { alwaysSendToDefaultTracker: false }
        );

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], "Kluwer Law Online - AccessibilityKLO");
        if (window.location.pathname == "/Maintenance") {
            const metaRobots = document.createElement('meta');
            metaRobots.name = 'robots';
            metaRobots.content = 'noindex';
            document.head.appendChild(metaRobots);
        }
       
    }
    render() {
        const meta = {
            title: "Kluwer Law Online - Accessibility Statement",
            canonical: window.location.href,
        }

        return (                        
            <DocumentMeta {...meta}>

                <div className="col-9 accessibility-statement" style={{ padding: '2% 4%' }}>
                   
             <h2>Accessibility Statement for <span class="basic-information website-name">Kluwer Law Online</span></h2>
                    <p>
                        <span class="basic-information organization-name">Kluwer Law International B.V.</span>
                        is committed to ensuring digital accessibility for people with disabilities.
                        We are continually improving the user experience for everyone, and applying the relevant accessibility standards.
                    </p>
                    <h3>Measures to support accessibility</h3>
                    <p>
                        <span class="basic-information organization-name">Kluwer Law International B.V.</span>
                        takes the following measures to ensure accessibility of
	                    <span class="basic-information website-name">Kluwer Law Online</span>:
                    </p>
                    <ul class="organizational-effort accessibility-measures">
                        <li>Appoint an accessibility officer and/or ombudsperson.</li>
                        <li>Provide continual accessibility training for our staff.</li>
                        <li>Assign clear accessibility targets and responsibilities.</li>
                    </ul>
                    <h3>Conformance status</h3>
                    <p>
                        The <a target="_blank" href="https://www.w3.org/WAI/standards-guidelines/wcag/">Web Content Accessibility Guidelines (WCAG)</a> defines requirements for designers and developers to improve accessibility for people with disabilities. It defines three levels of conformance: Level A, Level AA, and Level AAA.
	<span class="basic-information website-name">Kluwer Law Online</span>
                        is
	<span class="basic-information conformance-status" data-printfilter="lowercase">partially conformant</span>
                        with
	<span class="basic-information conformance-standard"><span data-negate="">WCAG 2.1 level AA</span>.</span>
                        <span>
                            <span class="basic-information conformance-status">Partially conformant</span>
                            means that
	<span class="basic-information conformance-meaning">some parts of the content do not fully conform to the accessibility standard</span>.
</span>
                    </p>
                    <h3>Additional accessibility considerations</h3>
                    <p class="basic-information conformance-additions">Although our goal is WCAG 2.1 Level AA conformance, we have also applied some Level AAA Success Criteria and we have performed an additional audit based on the Section 508 of the Rehabilitation Act of 1973 standards. </p>
                    <h3>Feedback</h3>
                    <p>
                        We welcome your feedback on the accessibility of
	<span class="basic-information website-name">Kluwer Law Online</span>.
                        Please let us know if you encounter accessibility barriers on
	<span class="basic-information website-name">Kluwer Law Online</span>:
</p>
                    <ul class="basic-information feedback h-card">
                        <li>
                            Phone:
	<span class="phone-number p-tel">+31 (0) 172 641500</span>
                        </li>
                        <li>
                            E-mail:
	<a class="email u-email" href="mailto:LRS-Compliance@wolterskluwer.comLRS-Compliance@wolterskluwer.comLRS-Compliance@wolterskluwer.comLRS-Compliance@wolterskluwer.comLRS-Compliance@wolterskluwer.com">LRS-Compliance@wolterskluwer.com</a>
                        </li>
                        <li>
                            Visitor address:
	<span class="visitor-address p-extended-address">Zuidpoolsingel 2, 2408 ZE, Alphen aan den Rijn, the Netherlands</span>
                        </li>
                        <li>
                            Postal address:
	<span class="postal-address p-adr">P.O. Box 316 2400 AH Alphen aan den Rijn</span>
                        </li>
                    </ul>
                    <p>
                        We try to respond to feedback within <span class="feedback responsetime">2 business days</span>.
</p>
                    <h3>Technical specifications</h3>
                    <p>                                                         
                        Accessibility of
	<span class="basic-information website-name">Kluwer Law Online</span>
                        relies on the following technologies to work with the particular combination of web browser and any assistive technologies or plugins installed on your computer:
</p>
                    <ul class="technical-information technologies-used">
                        <li>HTML</li>
                        <li>WAI-ARIA</li>
                        <li>CSS</li>
                        <li>JavaScript</li>
                    </ul>
                    <p>These technologies are relied upon for conformance with the accessibility standards used.</p>
                    <h3>Limitations and alternatives</h3>
                    <p>
                        Despite our best efforts to ensure accessibility of
	<span class="basic-information website-name">Kluwer Law Online</span>, there may be some limitations. Below is a description of known limitations, and potential solutions. Please contact us if you observe an issue not listed below.
</p>
                    <p>
                        Known limitations for
	<span class="basic-information website-name">Kluwer Law Online</span>:
</p>
                    <ol class="technical-information accessibility-limitations">
                        <li><strong>Filtering functionality on SERP</strong>: The ability to use the filtering functionality can not yet be performed using only the keyboard because there are some technical difficulties in our implementation. We are working on a better implementation and in the near future we will be able to provide this functionality with no limitations. .</li>
                        <li><strong>Table of contents alert (ETOC)</strong>: The ability to register to a table of content alert can not yet be performed using only the keyboard because there are some technical difficulties in our implementation. We are working on a better implementation and in the near future we will be able to provide this functionality with no limitations. .</li>
                        <li><strong>Share a publication through Email</strong>: The ability to share a publication though Email using our Email Sharing button can not yet be performed using only the keyboard because there are some technical difficulties in our implementation. We are working on a better implementation and in the near future we will be able to provide this functionality with no limitations. In the meantime you can copy the publication url from the address bar and send it though your personal email application.</li>
                    </ol>
                    <h3>Assessment approach</h3>
                    <p>
                        <span class="basic-information organization-name">Kluwer Law International B.V.</span>
                        assessed the accessibility of
	                        <span class="basic-information website-name">Kluwer Law Online</span>
                        by the following approaches:
                    </p>
                    <ul class="technical-information assessment-approaches">
                        <li>Self-evaluation</li>
                    </ul>
                    <hr noshade="noshade" />
                        <p>
                            This statement was created on
	                        <span class="basic-information statement-created-date">23 September 2020</span>
                        using the <a target="_blank" href="https://www.w3.org/WAI/planning/statements/">W3C Accessibility Statement Generator Tool</a>.
                        </p>                    
           
            </div>

            </DocumentMeta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/AccessibilityKLO.jsx